import {
  LayoutDashboard, GitBranch, Layers, ShieldCheck, Activity, FlaskConical,
  MessageSquare, Sparkles, Lightbulb, Bell, DatabaseZap, Users, ScrollText,
  Settings, Building2, Gauge,
} from "lucide-react";

export const NAV = [
  { section: "Overview", items: [
    { label: "Dashboard", path: "/app", icon: LayoutDashboard, min: "viewer" },
  ]},
  { section: "Process Intelligence", items: [
    { label: "Process Map", path: "/app/process-map", icon: GitBranch, min: "viewer" },
    { label: "Assessment", path: "/app/assessment", icon: Gauge, min: "viewer" },
    { label: "Variant Explorer", path: "/app/variants", icon: Layers, min: "viewer" },
    { label: "Conformance", path: "/app/conformance", icon: ShieldCheck, min: "viewer" },
    { label: "Performance", path: "/app/performance", icon: Activity, min: "viewer" },
    { label: "Simulation", path: "/app/simulation", icon: FlaskConical, min: "analyst" },
  ]},
  { section: "AI Analyst", items: [
    { label: "AI Chat", path: "/app/ai-chat", icon: MessageSquare, min: "viewer" },
    { label: "Insights & RCA", path: "/app/insights", icon: Sparkles, min: "viewer" },
    { label: "Recommendations", path: "/app/recommendations", icon: Lightbulb, min: "viewer" },
  ]},
  { section: "Operations", items: [
    { label: "Monitoring", path: "/app/monitoring", icon: Bell, min: "viewer" },
    { label: "Data Studio", path: "/app/data", icon: DatabaseZap, min: "connector_admin" },
  ]},
  { section: "Administration", items: [
    { label: "Users & Roles", path: "/app/users", icon: Users, min: "admin" },
    { label: "Audit Log", path: "/app/audit", icon: ScrollText, min: "admin" },
    { label: "Settings", path: "/app/settings", icon: Settings, min: "admin" },
  ]},
  { section: "Platform", items: [
    { label: "Super Admin", path: "/app/super-admin", icon: Building2, min: "super_admin" },
  ]},
];
